export default "__VITE_ASSET__196fb190__"